
import { Component, Vue, Prop } from 'vue-property-decorator'

import whitelabelModule from '@/store/whitelabel'
import listModule from '@/store/list'
import { TextFieldRules } from '@/utils/enums'

@Component({
  name: 'AdminEditor'
})
class AdminEditor extends Vue {
  @Prop() readonly edit?: boolean

  private rules = TextFieldRules
  private loading = false

  private form = {
    email: ''
  }

  private get admin() {
    return whitelabelModule.admin
  }

  private created() {
    if (this.edit) {
      this.form.email = this.admin!.email
    }
  }

  private async saveAdmin() {
    this.loading = true

    if (!this.edit) {
      await whitelabelModule.createAdmin({
        whitelabel: whitelabelModule.whitelabel._id,
        email: this.form.email
      })

      await whitelabelModule.fetchAllAdmins({
        limit: listModule.perPage
      })

      this.loading = false
      document.dispatchEvent(new Event('close-admin'))
    }
  }
}

export default AdminEditor
